// Зеркало настройки «Отображение всплывающих уведомлений» из окна
// «Уведомления». Источник истины — бэкенд (RTK Query,
// GetNotificationSettings; свич — агрегат по каналу in-app), но
// realtime-хук читает значение синхронно в момент показа тоста, поэтому
// держим копию в localStorage: обновляется при каждом ответе GET и при
// переключении свича, переживает перезагрузку. Тот же подход, что у
// useSidebarOpenKeys / useLeadsSectionMemory.
// Недоступное хранилище (приватный режим) или отсутствие ключа означает
// поведение по умолчанию — тосты показываются.
const STORAGE_KEY = 'notifications:popup-enabled';

export const readPopupNotificationsEnabled = (): boolean => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
};

export const writePopupNotificationsEnabled = (isEnabled: boolean): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(isEnabled));
  } catch {
    // Хранилище недоступно — настройка действует до перезагрузки страницы,
    // как и остальные локальные настройки.
  }
};
